import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import Payment3dsPopup from 'src/components/Payment3dsPopup';
import Pay2MePopup from 'src/components/Pay2MePopup';
import ErrorPopupContainer from '../containers/ErrorPopupContainer';
import SuccessPopupContainer from '../containers/SuccessPopupContainer';
import Header from './Header/Header';
import MainContent from './MainContent';

import PaymentHidden3dsPopup from '../../../components/PaymentHidden3dsPopup';
import ProcessingOverlay from './ProcessingOverlay';

const GlobalStyle = createGlobalStyle`
  input[type='checkbox'] {
    border: initial;
  }
`;
const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

const Layout = () => (
  <AppContainer>
    <GlobalStyle />

    <Header />
    <MainContent />
    <ProcessingOverlay />

    <ErrorPopupContainer />
    <Pay2MePopup />
    <Payment3dsPopup />
    <SuccessPopupContainer />
    <PaymentHidden3dsPopup />
  </AppContainer>
);

export default Layout;
